module.exports = __webpack_public_path__ + "static/media/call11.3eab25ba.gif";